import { Box, Text } from '@factorialco/deprecated-design-system'

import Sidepanel from 'modules/core/components/Sidepanel'
import i18n from 'modules/core/lib/i18n'

interface Props {
  open: boolean
  setOpen: (newValue: boolean) => void
}

export const HelpSidepanel = ({ open, setOpen }: Props) => (
  <Sidepanel
    onClose={() => {
      setOpen(false)
    }}
    open={open}
    width="narrow"
    title={i18n.t('ats.insights_page.hiring_stages_funnel_chart.help_sidepanel.title')}
  >
    <Box paddingBottom="s16">
      <Text.Normal weight="semibold">
        {i18n.t('ats.insights_page.hiring_stages_funnel_chart.help_sidepanel.question_1')}
      </Text.Normal>
      <Text.Normal>
        {i18n.t('ats.insights_page.hiring_stages_funnel_chart.help_sidepanel.answer_1')}
      </Text.Normal>
    </Box>
    <Box paddingBottom="s16">
      <Text.Normal weight="semibold">
        {i18n.t('ats.insights_page.hiring_stages_funnel_chart.help_sidepanel.question_2')}
      </Text.Normal>
      <Text.Normal>
        {i18n.t('ats.insights_page.hiring_stages_funnel_chart.help_sidepanel.answer_2')}
      </Text.Normal>
      <Box flexDirection="row" gap="s16" alignItems="center">
        <Box width="s200" paddingLeft="s16" alignItems="center">
          <Box
            paddingX="s16"
            paddingY="s8"
            border={{ bottom: { width: 's1', style: 'solid', color: 'grey800' } }}
          >
            <Text.Normal size="100" inline>
              {i18n.t(
                'ats.insights_page.hiring_stages_funnel_chart.help_sidepanel.answer_2_formula_a'
              )}
            </Text.Normal>
          </Box>
          <Box paddingX="s16" paddingY="s8">
            <Text.Normal size="100" inline>
              {i18n.t(
                'ats.insights_page.hiring_stages_funnel_chart.help_sidepanel.answer_2_formula_b'
              )}
            </Text.Normal>
          </Box>
        </Box>
        <Text.Normal size="100">x 100</Text.Normal>
      </Box>
    </Box>
    <Box paddingBottom="s16">
      <Text.Normal weight="semibold">
        {i18n.t('ats.insights_page.hiring_stages_funnel_chart.help_sidepanel.question_3')}
      </Text.Normal>
      <Text.Normal>
        {i18n.t('ats.insights_page.hiring_stages_funnel_chart.help_sidepanel.answer_3')}
      </Text.Normal>
    </Box>
  </Sidepanel>
)
